<template>
  <div>
    <el-dialog title="同步提示" :visible.sync="dialogVisible" :show-close="false" :close-on-press-escape="false" width="30%"
      :close-on-click-modal="false">
      <p style="font-size:20px">
        <i class="el-icon-success" style="color:#67C23A"></i>
        &nbsp;
        <span>开始同步</span>
      </p>
      <p style="font-size:20px">
        <i class="el-icon-success" ref="fileHandle"></i>
        &nbsp;&nbsp;
        <span>文件处理 <span ref="progress"></span></span>
      </p>
      <p style="font-size:20px">
        <i class="el-icon-success" ref="ipaParse"></i>
        &nbsp;
        <span>IPA解析&nbsp;</span>
      </p>
      <p style="font-size:20px">
        <i class="el-icon-success" ref="syncFinish"></i>
        &nbsp;
        <span>同步完成</span>
      </p>
    </el-dialog>
    <WebSocket v-on:webSocketHandle="webSocketHandle" />
  </div>
</template>
<script>
var self;
import WebSocket from "./WebSocket";
export default {
  props: ["fenfaSyncTaskNum"],
  components: {
    WebSocket
  },
  data() {
    return {
      dialogVisible: true
    };
  },
  mounted() {
    self = this;
  },
  methods: {
    handleClose: function() {
      this.$emit("closeFenfaSyncWindow");
    },
    webSocketHandle: function(data) {
      console.log("tag", data);
      var jsonData = JSON.parse(data);
      if (
        jsonData.businessId != 2 ||
        this.fenfaSyncTaskNum != jsonData.taskNum
      ) {
        return;
      }
      if (jsonData.opt == "fileHandle") {
        this.$refs.fileHandle.style = "color:#67C23A";
        this.$refs.progress.innerText = jsonData.body + "%";
      }
      if (jsonData.opt == "syncFail") {
        if (jsonData.body == null || jsonData.body == "") {
          return;
        }
        this.$notify.error({
          title: "错误提示",
          message: jsonData.body
        });
      }
      if (jsonData.opt == "ipaParse") {
        this.$refs.ipaParse.style = "color:#67C23A";
      }
      if (jsonData.opt == "syncFinish") {
        this.$refs.syncFinish.style = "color:#67C23A";
        setTimeout(() => {
          self.$emit("closeFenfaSyncWindow");
          self.$router.push("/apps");
        }, 2000);
      }
    }
  }
};
</script>
<style scoped>
.content {
  text-align: left;
}
.modal-body {
  text-align: center;
}
.form-check {
  margin-right: 1em;
  margin-left: 0;
}
.modal-footer button {
  text-align: center;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/FenfaSync.vue